function xAxesTimeFormat(dateRangeIndex) {
  switch (dateRangeIndex) {
    // last 5 min
    case "0":
      return {
        unit: "minute",
        displayFormats: {
          millisecond: "MMM[/]DD",
          second: "MMM[/]DD",
          minute: "h:mm:ss a",
          hour: "h:mm:ss a",
          day: "MM[/]DD",
          week: "MM[/]DD",
          month: "MM[/]DD",
          quarter: "MMM[/]DD",
          year: "MM[//]DD"
        }
      };
    // last hour
    case "1":
      return {
        unit: "minute",
        stepSize: 10,
        displayFormats: {
          millisecond: "MMM[/]DD",
          second: "MMM[/]DD",
          minute: "h:mm:ss a",
          hour: "h:mm:ss a",
          day: "MM[/]DD",
          week: "MM[/]DD",
          month: "MM[/]DD",
          quarter: "MMM[/]DD",
          year: "MM[//]DD"
        }
      };
    // last 3,6 hours; 
    case "2":
    case "3":
      return {
        unit: "hour",
        stepSize: 1,
        displayFormats: {
          millisecond: "MMM[/]DD",
          second: "MMM[/]DD",
          minute: "MMM[/]DD",
          hour: "h:mm:ss a",
          day: "MM[/]DD",
          week: "MM[/]DD",
          month: "MM[/]DD",
          quarter: "MMM[/]DD",
          year: "MM[//]DD"
        }
      };
    //last day
    case "4":
      return {
        unit: "hour",
        stepSize: 2,
        displayFormats: {
          millisecond: "MMM[/]DD",
          second: "MMM[/]DD",
          minute: "MMM[/]DD",
          hour: "h:mm:ss a",
          day: "MM[/]DD",
          week: "MM[/]DD",
          month: "MM[/]DD",
          quarter: "MMM[/]DD",
          year: "MM[//]DD"
        }
      };
    //last 1 second
    case "6":
      return {
        unit: "second",
        stepSize: 10,
        displayFormats: {
            millisecond: "MMM[/]DD",
            second: "HH:mm:ss",
            minute: "h:mm:ss a",
            hour: "h:mm:ss a",
            day: "MM[/]DD",
            week: "MM[/]DD",
            month: "MM[/]DD",
            quarter: "MMM[/]DD",
            year: "MM[//]DD",
        },
      };
    // last 7 day , custom
    case "5":
      // case 7 為 last_month
    case "7":
        return {
            unit: "day",
            displayFormats: {
                millisecond: "MMM[/]DD",
                second: "MMM[/]DD",
                minute: "MMM[/]DD",
                hour: "h:mm:ss a",
                day: "MM[/]DD",
                week: "MM[/]DD",
                month: "MM[/]DD",
                quarter: "MMM[/]DD",
                year: "MM[//]DD",
            },
        };
    // case 8 為 this_month
    case "8":
        return {
            unit: "day",
            displayFormats: {
                millisecond: "MMM[/]DD",
                second: "MMM[/]DD",
                minute: "MMM[/]DD",
                hour: "h:mm:ss a",
                day: "MM[/]DD",
                week: "MM[/]DD",
                month: "MM[/]DD",
                quarter: "MMM[/]DD",
                year: "MM[//]DD",
            },
        };
    case "99":
      return {
        unit: "day",
        displayFormats: {
          millisecond: "MMM[/]DD",
          second: "MMM[/]DD",
          minute: "MMM[/]DD",
          hour: "h:mm:ss a",
          day: "MM[/]DD",
          week: "MM[/]DD",
          month: "MM[/]DD",
          quarter: "MMM[/]DD",
          year: "MM[//]DD"
        }
      };
  }
}

export { xAxesTimeFormat };



// WEBPACK FOOTER //
// ./src/libs/xAxesTimeFormat.js